import {
  EpicPassValidateDocument,
  EpicPassValidateQueryResult,
  EpicPassValidateQueryVariables,
} from "@graphql/api";

export default async function epicPassValidate({ id }: { id: string }): Promise<boolean> {
  const client = global.window.apolloClient;

  const vars: EpicPassValidateQueryVariables = { passId: id };
  const result: EpicPassValidateQueryResult = await client.query({
    query: EpicPassValidateDocument,
    variables: vars,
  });

  return !!result?.data?.epicPassValidate.valid;
}
